import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "@mui/material/Button";

import styles from "./style.module.scss";

interface AnswerTrueFalseProps {
  value?: boolean | null;
  answers: { id: number; answer: string; is_correct: boolean }[];
  onAnswer: (answer: boolean) => void;
}

const AnswerTrueFalse: React.FC<AnswerTrueFalseProps> = ({ value, answers, onAnswer }) => {
  const { t } = useTranslation();
  
  const [selectedAnswer, setSelectedAnswer] = useState<boolean | null>(value ?? null);

  const correctAnswer = answers.find(ans => ans.is_correct)?.answer === 'True';

  const handleAnswer = (answer: boolean) => {
    if (selectedAnswer === answer) {
      setSelectedAnswer(null);
      return;
    }

    setSelectedAnswer(answer);
    onAnswer(answer);
  }

  const getButtonStyle = (isTrue: boolean) => {
    let baseStyle = styles.answerButton;
    
    if (selectedAnswer === isTrue) {
      const isCorrect = selectedAnswer === correctAnswer;
      baseStyle += isCorrect ? ` ${styles.correct}` : ` ${styles.incorrect}`;
    }
    
    return baseStyle;
  };

  return (
    <div className={styles.container}>
      <Button
        variant="outlined"
        classes={{
          root: getButtonStyle(true),
          disabled: styles.answerButton_disabled,
        }}
        color='secondary'
        onClick={() => handleAnswer(true)}
        disabled={selectedAnswer !== null}
      >
        {t('globals.true')}
      </Button>

      <Button
        variant="outlined"
        classes={{
          root: getButtonStyle(false),
          disabled: styles.answerButton_disabled,
        }}
        color='secondary'
        onClick={() => handleAnswer(false)}
        disabled={selectedAnswer !== null}
      >
        {t('globals.false')}
      </Button>
    </div>
  );
};

export default AnswerTrueFalse;
